import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { useCheckoutValidation } from '@/composables/useCheckoutValidation';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutView',
  setup(__props) {

const router = useRouter();

// 1. Inclua o isProcessing aqui na desestruturação
const { form, errors, isProcessing, validateForm } = useCheckoutValidation();

const handlePayment = async () => {
  // 2. Valida primeiro
  if (!validateForm()) return;

  // 3. Ativa o estado de processamento
  isProcessing.value = true;

  try {
    // Simula uma chamada de API de 2 segundos
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Sucesso!
    router.push({ name: 'success' });
  } catch (error) {
    alert("Erro ao processar pagamento");
  } finally {
    // 4. Desativa o loading independente de dar erro ou sucesso
    isProcessing.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _unref(isProcessing),
    onClick: handlePayment
  }, _toDisplayString(_unref(isProcessing) ? 'Processando...' : 'Finalizar Compra'), 9, _hoisted_1))
}
}

})